module.exports = __webpack_public_path__ + "media/img/pages/profile/zhaw ger 3-bcbf9eb3623182f5fdb5d2b31150ebcc.jpg";